var map = {
	"./abc-block.png": "3db0",
	"./add-user.svg": "5119",
	"./announcement.svg": "ddc2",
	"./book-open.svg": "fe38",
	"./book.svg": "a337",
	"./calendar.svg": "6bca",
	"./chart.svg": "ef55",
	"./chevron-down.svg": "c963",
	"./country.svg": "9d71",
	"./courses.svg": "6cd7",
	"./delete-icon.svg": "8c5c",
	"./delete.svg": "a91f",
	"./download.svg": "0339",
	"./edit-green.svg": "a59a",
	"./edit-icon.svg": "b67a",
	"./edit.svg": "c560",
	"./export.svg": "fd49",
	"./fwd-icon.svg": "26cb",
	"./grid.svg": "5113",
	"./import.svg": "7bc2",
	"./info-icon.svg": "54b3",
	"./journal.svg": "4083",
	"./library.svg": "89a5",
	"./list.svg": "a93e",
	"./logout.svg": "c5d0",
	"./message.svg": "2931",
	"./my-class.svg": "d0df",
	"./pen.svg": "66b2",
	"./play-icon.svg": "5806",
	"./plus.svg": "6cf9",
	"./profile-icon.svg": "fb14",
	"./quarter-grade.svg": "82c9",
	"./report.svg": "a7b3",
	"./ring-bell.svg": "4191",
	"./schedule.svg": "0529",
	"./schools.svg": "aedb",
	"./search.svg": "f919",
	"./send-icon.svg": "2610",
	"./setting.svg": "f754",
	"./students.svg": "3ae4",
	"./teachers.svg": "0c90",
	"./trash.svg": "a3e6",
	"./videocam.svg": "a6f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";